const convertPriceToNumber = (price: string | number) => {
  const formattedNum = Number(price?.toString().replace(/,/g, ""));
  return formattedNum;
};

export default convertPriceToNumber;
